import { Component } from '@angular/core';

@Component({
  selector: 'app-menu-vendre',
  templateUrl: './menu-vendre.component.html',
  styleUrls: ['./menu-vendre.component.scss']
})
export class MenuVendreComponent {

  openModal : boolean = false
  openModalEstimation(){
    this.openModal = !this.openModal
    setTimeout(() => {
      this.openModal = true
    }, 5);
  }
}
